import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-php-task',
	templateUrl: './php-task.component.html',
	styleUrls: ['./php-task.component.css'],
})
export class PhpTaskComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 3;
	protected parentComponent = 'tasks';
	data = {
		id: null,
		owners: [],
		deadline: null,
		content: null,
		status: null,
		ownerName: null,
		objId: null,
		objLink: null,
		objTypeName: null,
		authorName: null,
	};
	showTransfer = false;
	transferToUser: string = null;
	users: Array<any> = [];
	tasksTypes: Array<any> = [];
	tasksObjTypes: Array<any> = [];

	protected loadBefore() {
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/tasksTypes/', (result, error) => {
			this.tasksTypes = result.data;
			this.loadData();
		});
		this.api.get('/tasksObjTypes/', (result, error) => {
			this.tasksObjTypes = result.data;
			this.loadData();
		});
	}

	protected convertData(data) {
		const type = this.tasksTypes.find((findObj) => findObj.id == data.type);
		data.typeName = type ? type.name : '?';
		const objType = this.tasksObjTypes.find((findObj) => findObj.id == data.objType);
		data.objTypeName = objType ? objType.name : '?';
		data.objLink = objType ? '/' + objType.link.replace('[id]', data.objId) : '';
		const author = this.users.find((findObj) => findObj.id == data.author);
		data.authorName = author ? author.name : '?';
		data.ownerName = '';
		data.owners.forEach((obj) => {
			const owner = this.users.find((findObj) => findObj.id == obj);
			data.ownerName += owner ? owner.name + ', ' : '?, ';
		});
		return data;
	}

	transferSave() {
		console.log(this.transferToUser);
		if (!this.transferToUser) {
			return;
		}
		this.data.owners = [this.transferToUser];
		this.api.put('/tasks/' + this.data.id, this.data, (result, error) => {
			if (error) {
				return;
			}
			this.router.navigate(['task']);
		});
	}

	taskEndShow() {
		this.question.ask('Czy na pewno zakończyć?', 'endAsk');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'endAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.data.status = 2;
			this.api.put('/tasks/' + this.data.id, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.router.navigate(['task']);
			});
		});
	}

	taskRestore() {
		this.data.status = 1;
		this.api.put('/tasks/' + this.data.id, this.data, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisano');
		});
	}
}
